import React from 'react'
import stylesCSS from './ImageIcon.module.css'
export const ImageIcon = ({url}) => {
    return (
        <div>
           <img src={url} className={stylesCSS.responsiveIcon} alt="" /> 
        </div>
    )
}
